module.exports = function (message, title) {
    // 警告メッセージダイアログ
    var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
    if (title) {
        dialog += '<div class="modal-paypal__ttl">' + title + '</div>';
    }
    dialog += '<div class="modal-paypal__description">' + message + '</div>';
    dialog += '<ul class="modal-paypal-buttons">';
    dialog += '<li><button type="button" class="button-gray btn-close" onclick="$.magnificPopup.close();">Close</button></li>';
    dialog += '</ul>';
    dialog += '</div>';

    $.magnificPopup.open({
        items: {
            src: dialog,
            type: 'inline'
        },
        settings: null,
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        callbacks: {
            open: function () {
                var $content = $(this.content);

                $content.on('click', '.btn-close', function () {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });

                var keydownHandler = function (e) {
                    if (e.keyCode == 27) {
                        $content.find('.btn-close').click();
                        return false;
                    }
                };
                $(document).on('keydown', keydownHandler);
            }
        }
    });
};
